import getAttributes from './attributes'
import getSync from './sync'

export default (locale) => {
    const attributes = getAttributes(locale)
    const sync = getSync(locale)

    return {
        attributes,
        sync,
    }
}



// WEBPACK FOOTER //
// ./src/settings/index.js